import { ReturnBearZod } from "../../return";

interface ReturnWithReturnBear {
  returnBear?: ReturnBearZod | null;
}

/**
 * Checks if the return has ReturnBear data.
 * Verifies that returnBear exists and has a returnBearCaseId.
 */
export function hasReturnBear(return_: ReturnWithReturnBear): boolean {
  return !!return_.returnBear?.returnBearCaseId;
}

/**
 * Checks if the return has a ReturnBear QR code (used for drop-off/boxless returns).
 */
export function hasReturnBearQrCode(return_: ReturnWithReturnBear): boolean {
  return !!return_.returnBear?.qrCodeUri;
}

/**
 * Checks if the return has a ReturnBear shipping label.
 */
export function hasReturnBearLabel(return_: ReturnWithReturnBear): boolean {
  return !!return_.returnBear?.shippingInfo?.shippingLabelUrl;
}

/**
 * Gets the ReturnBear QR code URI if available.
 */
export function getReturnBearQrCodeUri(
  return_: ReturnWithReturnBear,
): string | undefined {
  return return_.returnBear?.qrCodeUri || undefined;
}

/**
 * Gets the ReturnBear shipping label URL if available.
 */
export function getReturnBearLabelUrl(
  return_: ReturnWithReturnBear,
): string | undefined {
  return return_.returnBear?.shippingInfo?.shippingLabelUrl || undefined;
}

/**
 * Gets the ReturnBear case ID if available.
 */
export function getReturnBearCaseId(
  return_: ReturnWithReturnBear,
): string | undefined {
  return return_.returnBear?.returnBearCaseId || undefined;
}

/**
 * Gets the ReturnBear case short ID if available.
 */
export function getReturnBearCaseShortId(
  return_: ReturnWithReturnBear,
): string | undefined {
  return return_.returnBear?.returnBearCaseShortId || undefined;
}

/**
 * Gets the ReturnBear tracking information if available.
 */
export function getReturnBearTracking(
  return_: ReturnWithReturnBear,
):
  | { carrierName: string; trackingNumber: string; trackingUrl: string }
  | undefined {
  const shippingInfo = return_.returnBear?.shippingInfo;
  if (!shippingInfo) {
    return undefined;
  }

  return {
    carrierName: shippingInfo.carrierName,
    trackingNumber: shippingInfo.trackingNumber,
    trackingUrl: shippingInfo.trackingUrl,
  };
}
